import cleareLocalStorage from './cleareLocalStorage';

export const PASSWORD_CHANGED_MESSAGE_SESSION_KEY = 'loginPasswordChanged';
export const PASSWORD_CHANGED_RELOGIN_MESSAGE = 'USERS_PASSWORD_CHANGED_RELOGIN_REQUIRED';

/** Marks that the user changed the password, so login shows the matching info (wins over "session expired"). */
export const markPasswordChanged = (): void => {
    sessionStorage.setItem(PASSWORD_CHANGED_MESSAGE_SESSION_KEY, '1');
};

/** Local-only logout (no API call, all tokens are already revoked) and redirect to login. */
export const logoutAfterPasswordChange = (): void => {
    markPasswordChanged();
    cleareLocalStorage();
    window.location.assign('/');
};
